var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('card',[_c('template',{slot:"header"},[_c('h3',[_c('i',{staticClass:"fad fa-list"}),_vm._v(" لیست جلسات ")]),_c('hr')]),_c('template',{slot:"content"},[_c('scrum-session-table',{attrs:{"Allsession":true}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }